
import Vue from 'vue';

export default Vue.extend({
	data(): { isOpen: boolean } {
		return {
			isOpen: false,
		};
	},
	props: {
		id: { type: String, default: 'default-collapse' },
	},
});
